import React, { type ReactElement } from 'react';

interface IconStars46Props {
  width?: number;
  height?: number;
  className?: string;
}

export function IconStars46({
  width = 105,
  height = 21,
  className,
}: IconStars46Props): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 105 21"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11.0079 3.50738C10.6873 2.60932 9.41125 2.62677 9.11541 3.53327L7.95105 7.10102C7.81679 7.51241 7.43314 7.79077 7.00039 7.79077H3.03235C2.10447 7.79077 1.67689 8.94473 2.38075 9.54933L5.88639 12.5606C6.18866 12.8203 6.30793 13.2346 6.18998 13.6152L4.96281 17.5751C4.67911 18.4906 5.7213 19.2422 6.50041 18.684L9.64684 16.4297C10.0072 16.1716 10.4945 16.1814 10.8441 16.454L13.8928 18.8308C14.6601 19.429 15.7432 18.6904 15.4663 17.7577L14.2262 13.5792C14.1115 13.193 14.2398 12.7757 14.5516 12.5207L18.1649 9.56477C18.8924 8.96969 18.4716 7.79077 17.5318 7.79077H13.2415C12.8188 7.79077 12.4418 7.525 12.2997 7.12691L11.0079 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M32.0079 3.50738C31.6873 2.60932 30.4112 2.62677 30.1154 3.53327L28.951 7.10102C28.8168 7.51241 28.4331 7.79077 28.0004 7.79077H24.0323C23.1045 7.79077 22.6769 8.94473 23.3808 9.54933L26.8864 12.5606C27.1887 12.8203 27.3079 13.2346 27.19 13.6152L25.9628 17.5751C25.6791 18.4906 26.7213 19.2422 27.5004 18.684L30.6468 16.4297C31.0072 16.1716 31.4945 16.1814 31.8441 16.454L34.8928 18.8308C35.6601 19.429 36.7432 18.6904 36.4663 17.7577L35.2262 13.5792C35.1115 13.193 35.2398 12.7757 35.5516 12.5207L39.1649 9.56477C39.8924 8.96969 39.4716 7.79077 38.5318 7.79077H34.2415C33.8188 7.79077 33.4418 7.525 33.2997 7.12691L32.0079 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M53.0079 3.50738C52.6873 2.60932 51.4112 2.62677 51.1154 3.53327L49.951 7.10102C49.8168 7.51241 49.4331 7.79077 49.0004 7.79077H45.0323C44.1045 7.79077 43.6769 8.94473 44.3808 9.54933L47.8864 12.5606C48.1887 12.8203 48.3079 13.2346 48.19 13.6152L46.9628 17.5751C46.6791 18.4906 47.7213 19.2422 48.5004 18.684L51.6468 16.4297C52.0072 16.1716 52.4945 16.1814 52.8441 16.454L55.8928 18.8308C56.6601 19.429 57.7432 18.6904 57.4663 17.7577L56.2262 13.5792C56.1115 13.193 56.2398 12.7757 56.5516 12.5207L60.1649 9.56477C60.8924 8.96969 60.4716 7.79077 59.5318 7.79077H55.2415C54.8188 7.79077 54.4418 7.525 54.2997 7.12691L53.0079 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M74.0079 3.50738C73.6873 2.60932 72.4112 2.62677 72.1154 3.53327L70.951 7.10102C70.8168 7.51241 70.4331 7.79077 70.0004 7.79077H66.0323C65.1045 7.79077 64.6769 8.94473 65.3808 9.54933L68.8864 12.5606C69.1887 12.8203 69.3079 13.2346 69.19 13.6152L67.9628 17.5751C67.6791 18.4906 68.7213 19.2422 69.5004 18.684L72.6468 16.4297C73.0072 16.1716 73.4945 16.1814 73.8441 16.454L76.8928 18.8308C77.6601 19.429 78.7432 18.6904 78.4663 17.7577L77.2262 13.5792C77.1115 13.193 77.2398 12.7757 77.5516 12.5207L81.1649 9.56477C81.8924 8.96969 81.4716 7.79077 80.5318 7.79077H76.2415C75.8188 7.79077 75.4418 7.525 75.2997 7.12691L74.0079 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M95.0079 3.50738C94.6873 2.60932 93.4112 2.62677 93.1154 3.53327L91.951 7.10102C91.8168 7.51241 91.4331 7.79077 91.0004 7.79077H87.0323C86.1045 7.79077 85.6769 8.94473 86.3808 9.54933L89.8864 12.5606C90.1887 12.8203 90.3079 13.2346 90.19 13.6152L88.9628 17.5751C88.6791 18.4906 89.7213 19.2422 90.5004 18.684L93.6468 16.4297C94.0072 16.1716 94.4945 16.1814 94.8441 16.454L97.8928 18.8308C98.6601 19.429 99.7432 18.6904 99.4663 17.7577L98.2262 13.5792C98.1115 13.193 98.2398 12.7757 98.5516 12.5207L102.165 9.56477C102.892 8.96969 102.472 7.79077 101.532 7.79077H97.2415C96.8188 7.79077 96.4418 7.525 96.2997 7.12691L95.0079 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <mask
        height="18"
        id="mask0_3439_24035"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="17"
        x="86"
        y="2"
      >
        <path
          clipRule="evenodd"
          d="M95.0079 3.50738C94.6873 2.60932 93.4112 2.62677 93.1154 3.53327L91.951 7.10102C91.8168 7.51241 91.4331 7.79077 91.0004 7.79077H87.0323C86.1045 7.79077 85.6769 8.94473 86.3808 9.54933L89.8864 12.5606C90.1887 12.8203 90.3079 13.2346 90.19 13.6152L88.9628 17.5751C88.6791 18.4906 89.7213 19.2422 90.5004 18.684L93.6468 16.4297C94.0072 16.1716 94.4945 16.1814 94.8441 16.454L97.8928 18.8308C98.6601 19.429 99.7432 18.6904 99.4663 17.7577L98.2262 13.5792C98.1115 13.193 98.2398 12.7757 98.5516 12.5207L102.165 9.56477C102.892 8.96969 102.472 7.79077 101.532 7.79077H97.2415C96.8188 7.79077 96.4418 7.525 96.2997 7.12691L95.0079 3.50738Z"
          fill="white"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_3439_24035)">
        <rect fill="#F3F3F0" height="17" rx="1" width="7" x="96" y="3" />
      </g>
    </svg>
  );
}
